import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Configuration } from '../../app.constants';
import { ServiceBase } from './base/base.service';

@Injectable()
export class UseTypeService extends ServiceBase {
  constructor(http: HttpClient, _configuration: Configuration) {
    super('use_type', http, _configuration);
  }
  public getMinMaxPosition<T>(): Observable<T> {
    return this.http.get<T>(`${this.actionUrl}${this.basePath}/minmax`);
  }
  public uploadImg<T>(id, file) {
    const formData: any = new FormData();
    formData.append('uploads[]', file, file['name']);
    return this.http.post<T>(
      `${this.actionUrl}${this.basePath}/${id}/img`,
      formData
    );
  }
  public uploadImgHeadline<T>(id, file) {
    const formData: any = new FormData();
    formData.append('uploads[]', file, file['name']);
    return this.http.post<T>(
      `${this.actionUrl}${this.basePath}/${id}/img/headline`,
      formData
    );
  }
}
